import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminWebhooksComponent } from './admin-webhooks.component';

const routes: Routes = [
  {
    path: '',
    component: AdminWebhooksComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminWebhooksRoutingModule {}
